
<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="出入库流水"
      :page="page"
      :show-query="true"
      :get-data-func="api.inOutStockStreamRpt"
      v-if="trendShow"
      :queryParamsAppend="params"
      urlHash="business/stock/water"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="onExport">导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="存货">
          <select-input
            placeholder="存货"
            :label="ProductName"
            v-model="params.ProductId"
            @click="openProduct"
            style="width: 180px"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <list-dialog ref="listDialog" in-dialog selectable @select="setProduct" />
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import listDialog from "@/components/basedata/inventory/archives/listDialog";

export default {
  mixins: [listMixin],
  components: { list, listDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/stock/stReport").default,
      trendShow: true,
      tableData: [],
      ProductName: "",
      params: {
        ProductId: null,
      },
    };
  },
  methods: {
    getSummary(param) {
      const { columns, data } = param;
      let labels = [
        "入库数量",
        "入库单价",
        "入库金额",
        "出库数量",
        "出库单价",
        "出库金额",
      ];

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (labels.includes(column.label)) {
            return Number(item[column.property]);
          }
        });

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    openProduct() {
      this.$refs.listDialog.open();
    },
    setProduct(data) {
      this.ProductName = data.ProductName;
      this.params.ProductId = data.ProductId;
    },
    onExport() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      // console.log('onExport', params);
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.inOutStockStreamRptExport(params).then((res) => {
        loading.close();
      });
    },
  },
};
</script>

